export default __webpack_public_path__ + "static/ambulance-2a613d51afe22458527b6974a8b6cd87.png";